// extracted by mini-css-extract-plugin
export var actionButton = "_jz-0";
export var actionMenuContainer = "_jz-i";
export var bubble = "_jz-2";
export var bubbleActionMenu = "_jz-j";
export var bubbleContext = "_jz-6";
export var bubbleItems = "_jz-7";
export var customer = "_jz-3";
export var divider = "_jz-8";
export var fileList = "_jz-9";
export var hiddenComment = "_jz-o";
export var infoAbove = "_jz-a";
export var internal = "_jz-4";
export var lightActionButton = "_jz-1";
export var link = "_jz-b";
export var merchant = "_jz-5";
export var message = "_jz-c";
export var profilePicture = "_jz-e";
export var quillToolbarContainer = "_jz-f";
export var senderDate = "_jz-g";
export var senderDateCustomer = "_jz-h";
export var senderName = "_jz-d";
export var time = "_jz-k";
export var uploadedImage = "_jz-l";
export var username = "_jz-m";
export var xsmall = "_jz-n";